import { render, staticRenderFns } from "./level.vue?vue&type=template&id=18b31261&"
import script from "./level.vue?vue&type=script&lang=ts&"
export * from "./level.vue?vue&type=script&lang=ts&"
import style0 from "./level.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports